import { postToAPI } from "./helpers/api";

var url = require("url");
// var fs = require('fs');
// var crypto = require("crypto");
//npm install request
// var request = require("request");
var Buffer = require('buffer/').Buffer

let mediaRecorder;

// Replace "###...###" below with your project's host, access_key and access_secret.
var defaultOptions = {
  host: "identify-eu-west-1.acrcloud.com",
  endpoint: "/v1/identify",
  signature_version: "1",
  data_type: "audio",
  secure: true,
  access_key: "c5e48b22e46231733ffec855458f6ba5",
  access_secret: "xqSdMBS88ceiPtUk7yPEoxmOG21T0vrPUYG8bqA2",
};


/**
 * Identifies a sample of bytes
 */
export async function identify(file, artist, setResponse) {
  try {
    const formData = new FormData();
    formData.append("sample", file);
    formData.append("sample_bytes", file.length);
    const json = await postToAPI(`identify?name=${artist}`, formData, null, true);
    // const res = await fetch(`http://localhost:3000/identify?name=${artist}`, {
    //   method: "POST", 
    //   body: formData
    // })
    console.log(json);
    if(!json.success || json.success !== true) {
      throw json.message;
    }
    // if(json.message.includes("You're not")) {
    //   throw json.message
    // }
    // const json = await res.json();
    setResponse(json); 
  } catch (error) {
    setResponse({ success: false })
  }  
}

export const startRecording = (setRecording, setResponse, artist) => {  
  setRecording(true);
  navigator.mediaDevices.getUserMedia({ audio: true })
  .then(stream => {
    mediaRecorder = new MediaRecorder(stream);
    mediaRecorder.start();

    const audioChunks = [];

    mediaRecorder.addEventListener("dataavailable", event => {
      audioChunks.push(event.data);
    });

    mediaRecorder.addEventListener("stop", async () => {
      const audioBlob = new Blob(audioChunks);
      const audioUrl = URL.createObjectURL(audioBlob);
      // const audio = new Audio(audioUrl);     
      const file = new File(audioChunks,'filename.mp3');
      await identify(file, artist, setResponse)
    });

    setTimeout(() => {
      stopRecording(setRecording, setResponse);      
    }, 10000);
  });
};

export const stopRecording = (setRecording) => {
  setRecording(false);
  mediaRecorder.stop();
  mediaRecorder.removeEventListener("dataavailable")
  mediaRecorder = null;
}